export const GERMAN = 'DE';
export const PORTUGUESE = 'PT';


// WEBPACK FOOTER //
// ./src/actions/language.js